export const arrowChevronLeftIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11"
     fill="none">
  <path
    d="M5.9715 0.0615892L7.24449 1.36004L3.30021 5.38322L7.24279 9.40467L5.9698 10.7031L0.753906 5.38355L5.9715 0.0615892Z"
    fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
